import React, {useState} from "react";
import { useTranslate } from 'react-redux-multilingual';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import swal from "sweetalert2";

// Style import
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArchive } from '@fortawesome/free-solid-svg-icons';

const  ArchiveActionButton = (props) => {
    const t = useTranslate();
    const [loadingArchive,setLoadingArchive]=useState(false) 

    return (
            <OverlayTrigger
                placement="bottom"
                overlay={
                    <Tooltip>
                        {t(props.nameType)}
                    </Tooltip>
                }
            >
                <span 
                    className={props.btnColor}
                    style={{cursor:'pointer'}} 
                    onClick={() => {
                        swal
                        .fire({
                            title: t(props.actionType)+" "+props.toArchive+"?",
                            icon: "warning",
                            type: "question",
                            showCancelButton: true,
                            confirmButtonColor: "#3085d6",
                            cancelButtonColor: "#d33",
                            confirmButtonText: t('btnYes'),
                            cancelButtonText: t('btnNo'),
                        })
                        .then((result) => {
                            if (result.value) {
                                props.customClickEvent(props.archiveFunctionArgument,setLoadingArchive)
                            }
                        });
                    }}
                >
                    {(loadingArchive) ? <div className="spinner-border spinner-border-sm"></div> : <FontAwesomeIcon icon={faArchive} />}
                </span>
            </OverlayTrigger>  
    )
}

export default ArchiveActionButton;